import React from 'react'
import { PageData } from '@api/home/detail/types'

export type Props = { data?: PageData['activityInfo']; className?: string }

export const countDown = (
  time: { startTime?: number; endTime: number },
  callback: Type.DefineFunc
) => {
  const { startTime, endTime } = time
  // 设置倒计时的结束时间
  var countdownDate = endTime ? Number(endTime) * 1000 : Date.now()
  var hz = 1000
  var now = Number(startTime) * 1000
  // 每秒更新倒计时
  var countdown = setInterval(function () {
    // 获取当前时间
    now = now + hz
    // 计算距离结束时间的时间差
    var distance = Number(countdownDate) - now

    // 计算剩余时间的天、时、分、秒
    var days = Math.floor(distance / (1000 * 60 * 60 * 24))
    days = Math.max(0, days)

    var hours = Math.floor(distance / (1000 * 60 * 60))
    hours = Math.max(0, hours)

    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    minutes = Math.max(0, minutes)

    var seconds = Math.floor((distance % (1000 * 60)) / 1000)
    seconds = Math.max(0, seconds)

    if (distance <= 0) {
      clearInterval(countdown)
      callback({ days, hours, minutes, seconds, isEnd: true })
      return
    } else {
      callback({ days, hours, minutes, seconds, isEnd: false })
    }
  }, hz)

  return {
    clear() {
      clearInterval(countdown)
    }
  }
}

export const useFlashSale = (data: PageData['activityInfo']) => {
  const [time, useTime] = React.useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isEnd: false
  })

  React.useEffect(() => {
    const handle = countDown(
      { endTime: Number(data?.endTime), startTime: Number(data?.nowTime) },
      (data: typeof time) => {
        useTime(data)
      }
    )
    return () => {
      handle.clear()
    }
  }, [JSON.stringify(data)])

  return { time, isEndsIn: time.hours < 72, isActivity: data.hasActivity === 1 }
}
